/**
 * 课程相关数据
 */
import {CourseResource} from "@/utils/http";

//二级缓存
function set(name, val) {
    if (val === "" || val === null) {
        sessionStorage.removeItem(name);
        return
    }
    if (typeof val === "object") {
        sessionStorage.setItem(name, JSON.stringify(val));
    } else {
        sessionStorage.setItem(name, val);
    }
}

function get(name) {
    const data = sessionStorage.getItem(name);
    if (data === null) {
        return ""
    }
    try {
        return JSON.parse(data);
    } catch (e) {
        return sessionStorage.getItem(name);
    }
}

export default {
    namespaced: true,
    state: {
        courseInfo: '', // 课程信息
        seriesInfo: '', // 系列信息
        editCourse: '', // 系列信息
    },
    getters: {
        getEditCourse: state => () => {
            if (!state.courseInfo) {
                state.editCourse = get("EDIT_COURSE");
            }
            return state.editCourse
        },
        getCourseInfo: state => () => {
            if (!state.courseInfo) {
                state.courseInfo = get("COURSE_INFO");
            }
            return state.courseInfo
        },
        getSeriesInfo: state => () => {
            if (!state.seriesInfo) {
                state.seriesInfo = get("SERIES_INFO");
            }
            return state.seriesInfo
        },
    },
    mutations: {
        setEditCourse(state, data) {
            state.editCourse = data;
            set("EDIT_COURSE", data);
        },
        setCourseInfo(state, data) {
            state.courseInfo = data;
            set("COURSE_INFO", data);
        },
        setSeriesInfo(state, data) {
            state.seriesInfo = data;
            set("SERIES_INFO", data);
        },
    },
    actions: {
        setCourseStatus(content, val) {
            if (!val) {
                val = content.getters.getSeriesInfo();
            }
            if (val.status === 0){
                return
            }
            const json = {
                id: val.id,
                classificationId: val.classificationId,
                status: 0
            };
            CourseResource.seriesStatus(json.id, json).then(res => {
              content.commit("setSeriesInfo", {...val, status: 0})
            });
        }
    }
}
